export const getUserLocationDescription = (user: {
  expose_location: boolean
  city: string | null
  country_title_local: string
}) => {
  const { expose_location, city, country_title_local } = user

  if (expose_location && city) {
    return `${city}, ${country_title_local}`
  }

  return country_title_local
}
